
import { CreditCard, Phone, Wallet } from 'lucide-react';
import type { ShippingOptionType } from './ShippingInformation';
import type { PaymentMethodType } from './PaymentMethod';

// Shipping options
export const shippingOptions: ShippingOptionType[] = [{
  id: 'standard',
  name: 'Standard Delivery',
  price: 0,
  days: '3-5'
}, {
  id: 'express',
  name: 'Express Delivery',
  price: 1500,
  days: '1-2'
}];

// Payment methods
export const paymentMethods: PaymentMethodType[] = [{
  id: 'card',
  name: 'Credit / Debit Card',
  icon: CreditCard
}, {
  id: 'momo',
  name: 'Mobile Money',
  icon: Phone
}, {
  id: 'flutterwave',
  name: 'Flutterwave',
  icon: Wallet
}];
